import { initializeApp, type FirebaseOptions } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const isDevMode = process.env.REACT_APP_DEV_MODE === 'true';

// DEVELOPMENT — must match finz-backend-v2 firebase-adminsdk.json project (finz-b1700).
// REACT_APP_FIREBASE_* in .env.dev override; apiKey should match backend FIREBASE_API_KEY.
const firebaseConfigDev: FirebaseOptions = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyB_7nxj4oLUOF0-cge-i1Li-jruXGdfius",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "finz-mvp.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "finz-mvp",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "finz-mvp.firebasestorage.app",
};
if (process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID) {
    firebaseConfigDev.messagingSenderId = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
}
else {
    firebaseConfigDev.messagingSenderId = "157768204182";
}

if (process.env.REACT_APP_FIREBASE_APP_ID) {
    firebaseConfigDev.appId = process.env.REACT_APP_FIREBASE_APP_ID;
}
else {
    firebaseConfigDev.appId = "1:157768204182:web:a9cd9ff6573001786767b7";
}

if (process.env.REACT_APP_FIREBASE_MEASUREMENT_ID) {
    firebaseConfigDev.measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;
}
else {
    firebaseConfigDev.measurementId = "G-QFGG66QNYY";
}

const firebaseConfig = isDevMode ? firebaseConfigDev :
    // PRODUCTION

    {
        apiKey: "AIzaSyDsnVhNC6bYZ2mtTZTtIC2yl7ZdIGUk8rM",
        authDomain: "app-finzcard-com.firebaseapp.com",
        projectId: "app-finzcard-com",
        storageBucket: "app-finzcard-com.firebasestorage.app",
        messagingSenderId: "999012941947",
        appId: "1:999012941947:web:af967ed4dc9a966fd0e2de",
        measurementId: "G-V3WPHE5X2C"
    };


const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
auth.settings.appVerificationDisabledForTesting = false;
export const provider = new GoogleAuthProvider();